module.exports = "img/social/facebook.b008f77.png";